import React from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../components/page/EmptyState';

function NotFoundPage() {
  return (
    <EmptyState
      action={(
        <Link className="inline-link" to="/dashboard">
          Go back to dashboard
        </Link>
      )}
      description="This route does not exist yet."
      title="Page not found"
    />
  );
}

export default NotFoundPage;
